import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {RoleService} from '@core/modules/role/services/role.service';
import {ERROR_PAGES_404_ROUTE} from '@core/constants/navigation/navigation.const';
import {Roles} from '@core/modules/role/enums/roles.enum';

@Injectable()
export class RolesGuard  {
  constructor(
    private roleService: RoleService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const roles: Roles[] = next.data.roles || [];
    if (!roles.length || this.roleService.hasRole(roles)) {
      return true;
    }

    this.router.navigateByUrl(ERROR_PAGES_404_ROUTE);
    return false;
  }
}
